'use client'

import { useEffect } from 'react'
import { QueryProvider } from '@/providers/query-provider'
import { Toaster } from 'sonner'
import { useAuthStore } from '@/stores/auth.store'
import { useNotificationStore } from '@/stores/notification.store'
import { useLocaleStore } from '@/stores/locale.store'
import { useFCMToken } from '@/hooks/useFCMToken'
import { LocaleProvider } from '@/lib/i18n'

// Rehydrate Zustand persist stores after React hydration completes.
// Without this, stores with skipHydration:true stay at their initial state
// (user=null) during SSR, preventing hydration mismatches.
function StoreHydration() {
  useEffect(() => {
    useAuthStore.persist.rehydrate()
    useNotificationStore.persist.rehydrate()
    useLocaleStore.persist.rehydrate()
  }, [])
  return null
}

// Initialize FCM push notification token after login
function FCMInitializer() {
  useFCMToken()
  return null
}

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryProvider>
      <LocaleProvider>
        <StoreHydration />
        <FCMInitializer />
        {children}
        <Toaster position="bottom-center" richColors closeButton />
      </LocaleProvider>
    </QueryProvider>
  )
}
